import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { AuthService } from '@app/_modules/auth/services/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { APP_PATH, GROUPS } from '@app/app.constants';
import { Group } from '@df/interfaces';
import { AccountService } from '@app/teacher/services/account.service';
import { AUTH_TOKEN } from '@app/_interceptors/auth.interceptor';
import { HandlerService } from '@app/_services/handler.service';

import { sortBy } from 'lodash';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
    @ViewChild('resetPasswordTemplate', { static: true }) ressetPasswordMsg: TemplateRef<any>;

    form: FormGroup;
    formResetPassword: FormGroup;
    hide = true;
    dialogRef: any;
    groups: Array<Group> = [];
    errors: Array<any>;
    showGroups = false;
    nextUrl = '';

    constructor(
        private authService: AuthService,
        private accountService: AccountService,
        private router: Router,
        public dialog: MatDialog,
        private handlerService: HandlerService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params.returnUrl) {
                this.nextUrl = params.returnUrl;
            }
        });
        // if (this.authService.isLoggedIn) {
        //     this.router.navigate([APP_PATH.profile.notifications]);
        // }

        this.authService.resetAuth();

        this.form = this.fb.group({
            group: ['', []],
            username: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(35)]],
            password: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(30)]]
        });

        this.formResetPassword = this.fb.group({
            group: ['', []],
            email: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(35), Validators.email]]
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    defaultProfileUrl(data): string {
        let url = APP_PATH.profile.main;
        if (data.group.name === GROUPS.TEACHER) {
            url = '/teacher/prepare';
        }

        if (data.group.name === GROUPS.PARENT) {
            url = APP_PATH.home;
        }

        if (data.group.name === GROUPS.STUDENT) {
            url = `${APP_PATH.profile.awards}/${data.user.id}`;
        }
        return url;
    }

    login(formData): void {
        this.authService.login(formData).subscribe(
            response => {
                if (response && !!response.access) {
                    localStorage.setItem(AUTH_TOKEN, response.access);

                    this.accountService.getProfileData().subscribe(resp => {
                        if (resp.data && resp.data.user.username) {
                            const url = this.defaultProfileUrl(resp.data);
                            // console.log(url, this.nextUrl);
                            this.router.navigate([this.nextUrl || url]);
                        }
                    });
                }
            },
            // @ts-ignore-line: параметор "error" небыл прочитан
            error => {
                this.groups = [];
                this.showGroups = false;
                const errorMsg = 'Логин и пароль не совпадают';
                this.handlerService.errorMsg(errorMsg);
            }
        );
    }

    onSubmit() {
        if (this.form.valid) {
            const { group, username, password } = this.form.value;
            const formData = {
                username: username,
                password: password
            };

            this.accountService.setCurrentGroupId(+group.id);
            this.accountService.getUserGroups(username).subscribe(resp => {
                if (resp.error) {
                    this.groups = [];
                    this.showGroups = false;
                    return;
                }

                if (!group.id && resp.data.length === 1) {
                    this.accountService.setCurrentGroupId(resp.data[0].id);
                    this.login(formData);
                    return;
                }
                this.groups = sortBy(resp.data, 'id').reverse();
                this.showGroups = true;
                this.form.patchValue({
                    group: resp.data[0]
                });

                if (group.id) {
                    // if (group.for_admin) {
                    //     this.authService.loginAdmin(formData).subscribe(resp => {
                    //         if (resp.error) {
                    //             this.groups = [];
                    //             this.showGroups = false;
                    //         }

                    //         if (resp.success) {
                    //             const adminUrl = `${location.origin}/admin/`;
                    //             window.open(adminUrl, '_self');
                    //         }
                    //     });
                    //     return;
                    // }
                    this.login(formData);
                }
            });
        }
    }

    changePassword() {
        this.dialogRef = this.dialog.open(this.ressetPasswordMsg, {
            width: '720px',
            height: '295px'
        });
    }

    changePasswordSubmit() {
        this.closeDialog();
        if (this.formResetPassword.valid) {
            const { email } = this.formResetPassword.value;

            this.accountService.changePassword(email).subscribe(resp => {
                if (resp.status) {
                    const msg = `На email ${email} было отправленно письмо`;
                    this.handlerService.infoMsg(msg);
                }
            });
        }
    }
}
